/**
 * Browser stand-in for `node:module`.
 *
 * The harness's client shell statically imports their vendored Cordis loader, and that
 * loader imports `node:module` for `createRequire` — which reads plugin packages from
 * disk. A browser does none of that: the client composes plugins from the boot graph and
 * their facade supplies the kernel. So the import must resolve to something, and their own
 * build resolves it to a stand-in too (`apps/web/src/node-module-stub.ts`, which this
 * mirrors) whose entire job is to fail loudly if that assumption ever changes.
 */
export const createRequire = (): never => {
  throw new Error("node:module is not available in the browser: plugins arrive through the boot graph here, not from disk");
};

/** Type-only peer for the vendored loader. */
export type LoadHookContext = never;
